module.exports = __webpack_public_path__ + "img/diners.4621d5d5.svg";